import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";

import HistoryFieldFilter, { HISTORY_FIELD_FILTER_OPERATORS } from "../../filters/HistoryField";

import Field, { FieldProperties } from "./Field";

class HistoryField extends Field {
  constructor(data: Omit<FieldProperties, "type">) {
    super({
      customFilterConfig: {
        defaultInstance: "historyField",
        filterInstances: {
          historyField: HistoryFieldFilter,
        },
        operators: HISTORY_FIELD_FILTER_OPERATORS,
      },
      features: [FieldFeature.FILTERABLE],
      platformFilterNames: ["updatedFields"],
      type: FieldType.STRING,
      ...data,
    });
  }
}

export default HistoryField;
